import React from "react";
import { TableHeadersType } from "../../../../constant/tableHeadersConstants/tableHeadersType";
import { ReceiptAndPaymentType } from "../../../../redux/reports/reportsType";
import ReceiptAndPaymentReceiptTableData from "./ReceiptAndPaymentReceiptTableData";
import { TableHeader, TableLoader } from "../../../commons";

type AppProps = {
  fetching: boolean;
  tableHeaders: TableHeadersType[];
  data: ReceiptAndPaymentType;
  currencySign: string | undefined;
};

const ReceiptAndPaymentReceiptTable = ({
  fetching,
  tableHeaders,
  data,
  currencySign,
}: AppProps) => {
  return (
    <div>
      <div className="jobsType">
        <table className="table table-bordered thead-light">
          {fetching ? (
            <TableLoader Rows={10} ColumnPerRow={8} />
          ) : (
            <>
              <thead className="text-start">
                <TableHeader tableHeader={tableHeaders} />
              </thead>
              <tbody>
                <ReceiptAndPaymentReceiptTableData
                  data={data}
                  tableHeaders={tableHeaders}
                  currencySign={currencySign}
                />
              </tbody>
            </>
          )}
        </table>
      </div>
    </div>
  );
};

export default ReceiptAndPaymentReceiptTable;
